
import React, { useState, useEffect } from "react";

import { useNavigate, useParams } from 'react-router-dom';
import SuccessAlert from '../child/Alert/SuccessAlert';
import DengerAlert from '../child/Alert/DengerAlert';
import Loader from "./../child/Loder";

const ViewUserPageNew = () => {
    const [joindate, setJoinDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [Data, setUserData] = useState("");
    const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
    const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
    const { id } = useParams();
  const isEditMode = !!id;


  const navigate = useNavigate();
  useEffect(() => {
    if (!id) return; // Ensure id is defined before making the request
  const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/userById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch Renter  data");
        }

        const data = await response.json();
        setUserData(data.result);
        const date = new Date(data.result.createdAt);
        if (!isNaN(date)) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = String(date.getFullYear());
            const formattedDate = `${day}-${month}-${year}`;
          setJoinDate(formattedDate);
        } else {
          console.error("Invalid date format:", data.result.createdAt);
          setJoinDate("Invalid Date");
        }
      } catch (err) {

        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id, navigate]); // Ensures the effect runs when id, edit mode, or navigation changes
   if (loading) {
      if (loading) return <Loader />;
    }

      return (
        <div className="row gy-4">

            <div className="col-lg-4">
            {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
            {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}

            </div>
            <div className="col-md-12">
                <div className="card h-100">
                    <div className="card-body p-24">
                        <ul
                            className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24 active"
                                    id="pills-edit-profile-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-edit-profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-edit-profile"
                                    aria-selected="true"
                                >
                                    Personal Information
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24"
                                    id="pills-change-passwork-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-change-passwork"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-change-passwork"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                  Upload Content
                                </button>
                            </li>


                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div
                                className="tab-pane fade show active"
                                id="pills-edit-profile"
                                role="tabpanel"
                                aria-labelledby="pills-edit-profile-tab"
                                tabIndex={0}
                            >
                                <form action="#">


                                    <div className="row">
                                    <div className="col-sm-6">
                                            <div className="mb-20">
                                            <span><b>Full Name</b></span>
                                               <p> {Data.fullName}</p>
                                            </div>

                                        </div>

                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                            <span><b>Email</b></span>
                                               <p> {Data.email}</p>
                                            </div>


                                        </div>

                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                            <span><b>Join Date </b></span>
                                                <p>{joindate}</p>
                                            </div>


                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="tab-pane fade" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                              <p> No Data Found</p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ViewUserPageNew;